import { render, staticRenderFns } from "./KETBetriebsordner.vue?vue&type=template&id=2e90077c&"
import script from "./KETBetriebsordner.vue?vue&type=script&lang=js&"
export * from "./KETBetriebsordner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports